import styled from "styled-components";
import { isMobile } from "react-device-detect";

export const DepositWithdrawalWrapper = styled.div`
  max-width: ${({ ingamedep, fistStep }) =>
    ingamedep && isMobile ? "90vw" : fistStep ? "1200px" : "800px"};
  width: 100%;
  padding: ${({ fistStep }) => (fistStep ? "0" : "1rem")};
  padding-top: ${({ ingamedep }) => ingamedep && "20px"};
  box-sizing: border-box;
  align-self: center;
  margin: 0 auto;

  .col2,
  .col3,
  .col4 {
    height: 100%;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }

  .col5 {
    width: 150px;
    transition: all 0.2s ease;
    pointer-events: auto;
    cursor: pointer;
  }

  .col1 {
    width: var(--depositCol1Width);
    height: var(--depositCol1Height);
  }
  button {
    width: var(--depositWrapperButtonWidth);
  }

  @media (max-width: 880px) {
    .col2,
    .col3,
    .col4 {
      font-size: 12px;
      line-height: 14px;
    }
    .col1 {
      width: 80px;
      height: 80px;
    }

    .col3 {
      visibility: hidden;
      width: 0px;
    }

    .col5 {
      font-size: 1rem;
      width: 120px;
    }
    button {
      font-size: 0.7rem !important;
      width: ${({ ingamedep }) =>
        ingamedep ? "85px !important" : "100px !important"};
    }
  }

  @media (max-width: 580px) {
    .col2 {
      visibility: hidden;
      width: 0px;
    }
  }
`;

export const DepositWithdrawalList = styled.div.attrs({
  className: "deposit-withdrawal-list",
})`
  min-height: ${({ ingamedep }) =>
    ingamedep ? "auto" : "calc(100vh - 100px - 2rem)"};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  width: 100%;

  button {
    &.btn-wd-dialog.unavailable,
    &.btn-deposit-dialog.unavailable {
      opacity: 0.5;
      cursor: not-allowed;
      &:hover {
        border-color: #fff;
      }
    }
  }
`;

export const DepositAndWithdrawalRow = styled.div.attrs({
  className: "deposit-withdrawal-row col-12",
})`
  background: ${({ dialogOpened }) =>
    dialogOpened ? "var(--depositRowBgDialogOpen)" : "var(--depositRowBg)"};
  border-radius: var(--depositRowBorderRadius);
  width: 100%;
  min-height: 70px;
  margin: 1rem 0;
  display: flex;
  justify-content: space-between;
  transition: all 0.2s ease;
  pointer-events: auto;
  cursor: pointer;
  align-items: center;
  opacity: ${({ testing }) => (testing ? "0.3" : "")};
  border-bottom: var(--depositRowBorderBottom);

  &:first-child {
    border-top: none;
  }

  & > p {
    color: var(--depositRowTextColor);
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  img {
    max-height: 70px;
  }

  @media (min-width: 768px) {
    img {
      margin-left: var(--depositRowImgMarginLeft);
    }
    button {
      margin-right: var(--depositRowButtonMarginRight);
    }
  }
`;

export const DepositWithdrawalText = styled.p.attrs({
  className: "mt-5 col-12",
})`
  color: var(--depositTextColor);
  opacity: var(--depositTextOpacity);
  font-size: 11px;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
`;

export const FrameBox = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  align-items: center;
  align-content: center;

  iframe {
    border: none;
    width: 100%;
    max-width: 1130px;
    background-color: #fff;
    border-radius: var(--depositFrameBorderRadius);
    border: 2px solid #fff;
  }
`;

export const PageheadlinePar = styled.p`
  color: var(--acolor);
  font-weight: 600;
  letter-spacing: 0.5px;
  font-size: 22px;
  text-align: ${({ center }) => (center ? "center" : "")};
  padding-top: var(--depositHeadlinePaddingTop);

  h3 {
    color: var(--depositHeadlineH3Color);
    font-weight: 600;
    letter-spacing: 0.5px;
    font-size: var(--depositHeadlineH3FontSize);
    text-align: ${({ center }) => (center ? "center" : "")};
  }
  @media (max-width: 580px) {
    width: 100%;
    font-size: 16px;
    line-height: 21px;
  }
`;

export const StyledWithdrawalDialog = styled.form`
  padding: ${({ inGame }) => (inGame ? "15px" : isMobile ? "0" : "15px")};

  button {
    font-size: var(--depositDialogButtonFontSize) !important;
    height: auto;
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-top: 0px;
    line-height: 37px;
    border-radius: var(--depositDialogButtonBorderRadius);
    font-weight: var(--depositDialogButtonFontWeight);

    &.button-first {
      background-size: cover;
    }
  }
  .form-group {
    label {
      color: var(--tabletext) !important;
      min-height: 15px;
      font-size: 10px;
      margin-bottom: 0.1rem;
    }
  }
  legend {
    color: var(--tabletext) !important;
    min-height: 15px;
    font-size: 15px;
    margin: var(--depositDialogLegendMargin);
  }

  input,
  select {
    color: var(--inputtext);
    font-weight: 800;

    &::placeholder {
      font-weight: 400;
      text-transform: capitalize;
      font-size: 0.85rem;
    }
  }
  .sort {
    margin-left: 0px;
    margin-right: 0px;
  }
  @media (max-width: 450px) {
    button {
      font-size: 14px !important;
    }
  }

  @media (max-width: 320px) {
    button {
      font-size: 12px !important;
    }
  }
  @media (min-width: 576px) {
    button {
      font-size: 26px;
      padding-top: var(--depositDialogButtonPaddingTopSm);
      padding-bottom: var(--depositDialogButtonPaddingBottomSm);

      &.button-first {
        background-size: 100% 100%;
      }
    }
    .form-group {
      label {
        font-size: 12px;
      }
    }
  }
  @media (min-width: 1200px) {
    button {
      height: 45px;
    }
  }
  @media (min-width: 992px) {
    button {
      font-size: 0.875rem !important;
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
    }
  }
`;

export const WithdrawalRow = styled.div`
  background: none;
  cursor: default;

  img {
    margin-right: 15px;
    margin-left: -5px;
  }

  &:hover {
    background: none;
  }

  .col2,
  .col3,
  .col4 {
    color: var(--tabletext);
    height: 100%;
    padding: 0;
    margin: 0;
    display: block;
    text-align: left;
    align-items: center;
    height: 20%;
    flex: 1;
    justify-content: flex-start;
    flex: 0;
    visibility: visible;
    width: 100%;
    font-size: 10px;
  }

  .col3 {
    visibility: visible;
  }
`;

export const WithdrawalImg = styled.img.attrs({
  className: "col-lg-2 col-sm-4 col-4",
})`
  padding: 0 !important;
`;

export const StyledColWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  align-items: flex-start;
  flex-direction: column;

  @media (min-width: 576px) {
    .col2,
    .col3,
    .col4 {
      font-size: 12px;
    }
  }

  @media (min-width: 992px) {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;

    .col2,
    .col3,
    .col4 {
      display: flex;
      text-align: initial;
    }

    .col3 {
      justify-content: center;
      flex: 1;
    }

    .col4 {
      justify-content: flex-end;
      flex: 1;
      height: 40%;
      border-bottom: 1px solid var(--depositBorder);
    }

    .col1,
    .col2,
    .col3 {
      border-bottom: 1px solid var(--depositBorder);
      height: 40%;
      flex: 1;
    }
  }
`;

export const WithdrawalFormGroup = styled.div.attrs((props) => ({
  className: `form-group col-12 text-left ${props.extraCol || ""}`.trim(),
}))`
  margin-bottom: var(--depositFormGroupMarginBottom);
`;

export const StyledWithdrawalDescription = styled.div.attrs({
  className: "mt-4 col-12 text-center",
})`
  color: var(--tabletext);
`;

export const CloseIframeWrapper = styled.div.attrs({
  className: "",
})`
  width: 100%;
  max-width: 1130px;
  position: relative;

  button {
    color: #908e8e;
    top: 0;
    ::after {
      font-size: 2rem;
    }
    @media (max-width: 580px) {
      top: 0px;
    }
    :hover {
      color: #b8b4b4;
    }
  }
`;
